<template>
	<div class="page-input-code">
		<div class="page-title">请输入机身上的8位编码</div>
		<div class="code" @click="tapCode">
			<input type="tel" maxlength="8" @input="watchInput" ref="codeInput" />
			<div class="code-item" v-for="(_, idx) in 8" :key="idx">{{ codeList[idx] || '' }}</div>
		</div>
		<div class="tips">
			<div class="image-title">编码在机身二维码的下方</div>
			<img :src="ossPondHost + 'img/device_code.png'" class="image" />
		</div>
		<div :class="['page-bottom', { active: codeList.length == 8 }]" @click="onclickNextBtn">确 认</div>
		<div class="page-cancel" @click="onclickCancelManual">返回扫码</div>
	</div>
</template>

<script>

export default {
	name: 'XiazengManualInput',
	data() {
		const { ossHostPond } = this.$config.base;
		return {
			ossPondHost: ossHostPond,
			codeList: []
		};
	},
	created() {
		this.$nextTick(() => {
			this.$refs.codeInput && this.$refs.codeInput.focus();
		});
	},
	methods: {
		// 监听输入
		watchInput(e) {
			const val = e.target.value.replace(/\D/g, '').slice(0, 8);
			e.target.value = val;
			this.codeList = val ? val.split('') : [];
		},

		// 点击输入框聚焦
		tapCode() {
			this.$refs.codeInput && this.$refs.codeInput.focus();
		},

		// 确认手动输入的编号
		onclickNextBtn() {
			const vm = this;
			const code = vm.codeList.join('');
			if (code.length !== 8) return;
			vm.confirmId(code);
		},

		// 确认编号，回传给上一页并返回
		confirmId(uniqueId) {
			// 先存储到 sessionStorage，再返回上一步
			sessionStorage.setItem('xiazengManualUniqueId', uniqueId);
			this.$router.back();
		},

		// 返回扫码页面
		onclickCancelManual() {
			this.$router.back();
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-input-code {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: @bgColor2;

	.page-title {
		margin: 0.3rem 0 0.5rem;
		font-weight: bold;
		font-size: 0.2rem;
		color: #454545;
	}

	.code {
		position: relative;
		width: 100%;
		height: 0.4rem;
		padding-left: 0.63rem;
		box-sizing: border-box;
		display: flex;

		input {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			z-index: 1;
			border: none;
			outline: none;
		}

		.code-item {
			width: 0.3rem;
			height: 0.4rem;
			font-size: 0.24rem;
			margin-left: 0.04rem;
			text-align: center;
			line-height: 0.4rem;
			border-bottom: 1px solid @textColor13;
			color: @themeColor;
			font-weight: bold;
			z-index: 100;
		}
	}

	.tips {
		margin-top: 0.4rem;
		font-size: 0.18rem;
		color: #454545;
		text-align: center;

		.image {
			margin-top: 0.1rem;
			width: 3.15rem;
			height: 2rem;
			display: block;
		}
	}

	.page-bottom {
		width: 2.5rem;
		height: 0.5rem;
		margin: 0.5rem auto 0;
		text-align: center;
		border-radius: 0.45rem;
		line-height: 0.5rem;
		font-size: 0.2rem;
		color: @blank;
		font-weight: bold;
		background: @textColor13;
		cursor: pointer;

		&.active {
			background: @themeColor;
		}
	}

	.page-cancel {
		margin-top: 0.2rem;
		font-size: 0.16rem;
		color: @textColor1;
		cursor: pointer;
	}
}
</style>